import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { IconWidget } from '@weatherbug/react';
import { translate } from  '../../common/translation/translate';
import { OneColumnDataDisplayRow } from './oneColumnDataDisplayRow';
import { TwoColumnDataDisplayRow } from './twoColumnDataDisplayRow';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

export const ResortConditions = memo(({
    temperature,
    iconCode,
    forecastIconSet,
    forecastIconSize,
    authId,
    secret,
    contentMgmtBaseUrl,
    stdParameters,
    forecastIconResourceList,
    baseSnow,
    newSnow,
    reported,
    feelsLike,
    highTemp,
    lowTemp,
    tempUnitAbbreviation,
    openStatusFlag,
    openStatus,
    totalLifts,
    openLifts,
    snowCondition
}) => {
    return (
        <Container>
            <TopConditions>
                <TempContainer>
                    <Temp>{temperature}°</Temp>
                    <IconWrapper>
                        <LazyLoadComponent threshold={100} useIntersectionObserver={true}>
                            <IconWidget
                                iconCode={iconCode}
                                iconSet={forecastIconSet}
                                iconSize={forecastIconSize}
                                authId={authId}
                                secret={secret}
                                contentManagementBaseUrl={contentMgmtBaseUrl}
                                stdParameters={stdParameters}
                                resourceList={forecastIconResourceList}
                            />
                        </LazyLoadComponent>
                    </IconWrapper>
                </TempContainer>
                <TopData>
                    <OneColumnDataDisplayRow title={translate('baseSnow')} value={baseSnow} />
                    <OneColumnDataDisplayRow title={translate('newSnow')} value={newSnow} />
                    <OneColumnDataDisplayRow title={translate('reportedSnow')} value={reported} />
                </TopData>
            </TopConditions>
            <FeelsLike>{translate('feelsLike')} {feelsLike}°</FeelsLike>
            <BottomConditions>
                <TwoColumnDataDisplayRow title={translate('forecastHigh')} value={highTemp} unit={tempUnitAbbreviation} />
                <TwoColumnDataDisplayRow title={translate('forecastLow')} value={lowTemp} unit={tempUnitAbbreviation} />
                <TwoColumnDataDisplayRow title={translate('resortStatus')} value={openStatus} openStatusFlag={openStatusFlag} />
                <TwoColumnDataDisplayRow title={translate('totalLifts')} value={totalLifts} />
                <TwoColumnDataDisplayRow title={translate('openLifts')} value={openLifts} />
                <TwoColumnDataDisplayRow title={translate('snowCondition')} value={snowCondition} />
            </BottomConditions>
        </Container>
    );
});

ResortConditions.displayName = 'ResortConditions';
ResortConditions.propTypes = {
    temperature: PropTypes.number,
    highTemp: PropTypes.any,
    lowTemp: PropTypes.any,
    tempUnitAbbreviation: PropTypes.string,
    iconCode: PropTypes.number,
    forecastIconSet: PropTypes.string,
    forecastIconSize: PropTypes.string,
    authId: PropTypes.string,
    secret: PropTypes.string,
    contentMgmtBaseUrl: PropTypes.string,
    stdParameters: PropTypes.object,
    forecastIconResourceList: PropTypes.string,
    baseSnow: PropTypes.any,
    newSnow: PropTypes.any,
    reported: PropTypes.string,
    feelsLike: PropTypes.number,
    openStatusFlag: PropTypes.number,
    openStatus: PropTypes.string,
    totalLifts: PropTypes.number,
    openLifts: PropTypes.any,
    snowCondition: PropTypes.string
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 20px;
`;

const TopConditions = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

const TempContainer = styled.div`
    width: 51%;
    display:flex;
    flex-direction: row;

`;

const Temp = styled.div`
    font-size: 28pt;
    font-style: normal;
    font-weight: 600;
    margin: 0 0 0 10px;
    top: 10px;
    color: #555;
`;

const IconWrapper = styled.div`
    margin: 0 40px 0 10px;
    & .wb-content-mgt-icon-image {
            width: 60px;
            height: 60px;
    }
`;

const TopData = styled.div`
    font-size: 12pt;
    display: inline-block;
    color: #999999;
    white-space: nowrap;
    width: 49%;
    max-width: 125px;
`;

const FeelsLike = styled.div`
    font-size: 12pt;
    color: #435560;
    margin: -20px 0 0 10px;
`;

const BottomConditions = styled.div`
    font-size: 12pt;
    margin: 10px 0 0 10px;
`;
